import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-color-grps',
  templateUrl: './color-grps.component.html',
  styleUrls: ['./color-grps.component.css']
})
export class ColorGrpsComponent implements OnInit {
    public setting?: Setting;

    public itemsListViews: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1205))[0];
    }

    private async loadViews() {
        this.itemsListViews = await this.datatask.Post(1204);
    }

    private async init() {
        this.loadSetting();
        this.loadViews();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    filterval: string;
}
